/** Sensor choreography on the trace clock; no frame-history or random state. */
export function nightHawkPass(journey: number) {
  const progress = Math.max(0, Math.min(1, journey));
  const aft = progress >= .5;
  return {
    aft,
    bearingOffset: (aft ? 180 : 0) + (Math.round(progress * 240) / 240 - .5) * 14,
    // The pass reaches its steepest look at the fore/aft transition.
    pitch: 12 + 24 * Math.abs(progress * 2 - 1),
  };
}

/** Retain the full output resolution for the clearer sensor treatment. */
export function nightHawkSensorSize(width: number, height: number) {
  return { width: Math.max(1, Math.round(width)), height: Math.max(1, Math.round(height)) };
}
